import axios from "axios";
import React from 'react';
import {
    auditIdHeader,
    basicAuthHeader,
    bearerTokenHeader,
    externalUserHeader,
    kernoCustomerIdHeader, poolCustomerIdHeader
} from "./auth-service";


export async function postAssert(assertModel) {
    let combinedHeaders = Object.assign(bearerTokenHeader(), auditIdHeader(), externalUserHeader(), kernoCustomerIdHeader());
    const response = await axios.post(process.env.REACT_APP_IP + '/v1/api/asserts/sign', assertModel, {
        headers: combinedHeaders
    });
    return response.data;
}

export async function getListOfEmissions() {
    const response = await axios.get(process.env.REACT_APP_IP + '/insurancehub/extraction/policies', {
        headers: auditIdHeader()
    });
    return response.data;
}

export async function getImpresionEmisionPDF(movementId) {
    const response = await axios.get(process.env.REACT_APP_IP + '/v1/api/emissions/' + movementId + '/print',
        {
            responseType: 'blob',
            headers: bearerTokenHeader()
        });
    return response.data;
}

export async function getImpresionEmisionPDFKerno(workOrderId) {
    const response = await axios.get(process.env.REACT_APP_IP + '/workorders/' + workOrderId + '/amazons3/url',
        {
            responseType: 'blob',
            auth: basicAuthHeader()
        });
    return response.data;
}

export async function getXMLRequestResponseEmission(workorderId) {
    const response = await axios.get(process.env.REACT_APP_IP + '/v1/api/asserts/sign/'+workorderId+'/request',
        {
            headers: bearerTokenHeader()
        });
    return response.data;
}

